import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, pluck, startWith } from 'rxjs/operators'

import * as actions from './actions'
import * as api from './api'

const sendDriftAppMetric = (action$) => {
  return action$.pipe(
    ofType(actions.sendDriftAppMetric.toString()),
    pluck('payload'),
    mergeMap((metric) =>
      api.sendDriftAppMetric(metric).pipe(
        map(() => actions.sendDriftAppMetricSuccess()),
        startWith(actions.sendDriftAppMetricPending()),
        catchError((error) => of(actions.sendDriftAppMetricFailed(error)))
      )
    )
  )
}

export const epic = combineEpics(sendDriftAppMetric)
